/**
 * Gera data URL PNG do QR a partir do otpauth URI (enrolamento TOTP).
 * Usado no browser para não depender só do qr_data_url do backend.
 * @param {string} otpauthUri
 * @returns {Promise<string>}
 */
export async function qrDataUrlFromOtpauth(otpauthUri) {
  const uri = String(otpauthUri || "").trim();
  if (!uri) {
    throw new Error("URI otpauth em falta.");
  }
  const QRCode = (await import("qrcode")).default;
  return QRCode.toDataURL(uri, {
    width: 200,
    margin: 2,
    errorCorrectionLevel: "M",
  });
}
